import { create } from "zustand";
import { persist } from "zustand/middleware";

import {
	DebugInfoState,
	DebugInfoActions
} from "./types";
import { PersistentStorageKey } from "../common/persistentStorageKey";

export const useDebugStore = create<DebugInfoState & DebugInfoActions>()(
	persist(
		(set, get) => ({
			debugInfo: {},
			pushDebugInfoItem: (key: string, value: any) => {
				const oldDebugInfo = get().debugInfo;

				let debugInfoArray = oldDebugInfo[key] || []
				debugInfoArray = [...debugInfoArray, { value, timestamp: new Date().toISOString() }];

				if (debugInfoArray.length > 10) {
					debugInfoArray = debugInfoArray.slice(debugInfoArray.length - 10);
				}

				set({
					debugInfo: { ...oldDebugInfo, [key]: debugInfoArray },
				});
			},
			removeDebugInfoItems: (keys: string[]) => {
				const oldDebugInfo = get().debugInfo;

				if (keys.every((x: string) => !oldDebugInfo[x])) {
					return;
				}

				const newDebugInfo = { ...oldDebugInfo };

				keys.forEach((x: string) => {
					newDebugInfo[x] = undefined;
				});

				set({ debugInfo: newDebugInfo });
			},
		}),
		{
			name: PersistentStorageKey.DebugStorage,
		}
	)
);
